module.exports = __webpack_public_path__ + "static/media/terms009.107b7ec7.png";